import React, { useState } from "react";
import { useDidMountEffect } from "./CustomHooks"

export const ProductVideos = () => {
    const [selectedVideo, setSelectedVideo] = useState(productModel.Videos[0])

    useDidMountEffect(() => {
        $("#product-video")[0].load();
        $("#product-video")[0].play();
    }, [selectedVideo])

    const videoThumbnails = [];
    productModel.Videos.forEach((video, i) => {
        videoThumbnails.push(
            <div key={`video-thumbnail-${i}`} onClick={() => setSelectedVideo(video)}
                className={"tw-cursor-pointer tw-text-[14px] tw-pb-[15px] tw-flex md:tw-flex-col tw-gap-x-[26px] md:tw-max-w-[200px] lg:tw-max-w-[250px] " + (i > 0 ? 'tw-mt-[24px]' : '')}
                style={i < productModel.Videos.length - 1 ? { borderBottom: "1.5px solid #C8C8C8" } : {}}>
                <img style={selectedVideo === video ? { boxShadow: "0 0 0 4px #A71635" } : {}}
                    className="tw-h-full md:tw-mb-[12px] tw-w-[140px] sm:tw-w-[200px] md:tw-w-auto" src={`/Content/ProductImages/300x225/${video.Name.split('.')[0] + '.jpg'}`} />
                <div className="tw-flex tw-flex-col">
                    <div className="tw-text-tamarillo-700 tw-mb-[4px] tw-font-bold" >{trimVideoWord(video.Description)}</div>
                    <div className="tw-mb-[6px]" >{video.Synopsis}</div>
                </div>
            </div>
        );
    })
    return (
        <div className="tw-flex tw-gap-[35px] tw-mt-[10px] tw-flex-col md:tw-flex-row">
            <div>
                <video id="product-video" className="tw-w-full md:tw-w-[63vw] lg:tw-w-[53vw] tw-max-w-[1128px] tw-cursor-pointer tw-aspect-[960/720]"
                    controls key={selectedVideo} title={selectedVideo.Description} alt={selectedVideo.AltText} 
                    poster={`/Content/ProductImages/960x720/${selectedVideo.Name.split('.')[0] + '.jpg'}`} >
                    <source src={`/Content/Videos/SD/${selectedVideo.Name}`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="tw-text-[22px] tw-font-bold tw-mt-[5px] tw-mb-[8px] mdtw-mb-0 md:tw-mt-[18px]">{trimVideoWord(selectedVideo.Description)}</div>
            </div>
            <div className="tw-flex tw-flex-col">{videoThumbnails}</div>
        </div>
    );

    function trimVideoWord(videoDes) {
        let words = videoDes.trim().split(" ");
        if (words.pop().localeCompare("video", undefined, { sensitivity: 'accent' }) === 0) {
            return words.join(" ");
        }
        else return videoDes.trim();
    }
}